export function decode(str: string): string {
  str = str.replace(new RegExp("-", "g"), "+");
  str = str.replace(new RegExp("_", "g"), "/");
  let result = window.atob(str);
  result = decodeURIComponent(escape(result));
  return result;
}
